export enum ClientRoleEnum {
  BUSINESS = 'business',
  DEVELOPER = 'developer',
}
